import { determinePageAssetId } from "./DeterminePageAssetId.function";
import { withoutDuplicateValues } from "./WithoutDuplicateValues.function";

export function withoutDuplicatePageAssetIdsFactory() {
    return withoutDuplicateValues(determinePageAssetId);
}
